import { useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import AnalyticsManager from '../../services/AnalyticsManager'

export const usePageTracking = () => {
  const location = useLocation()
  const { pathname, search } = location
  
  const getPath=useCallback(()=>{
    if(!pathname) return '/'
    else if(pathname==='/dashboard/profile') return '/profile'
    else return pathname
  },[pathname])

  useEffect(() => {
    AnalyticsManager.trackTypedEvent({
      event: 'Page View - Web',
      path: getPath(),
      search,
      source: 'Web App'
    })
  }, [search, getPath])
}
